import React from 'react'

import styles from './styles.module.scss'

const LoanTypeModal = () => (
  <div className={styles.modalWrapper}>
    <p className="semiBold">Conventional Loan</p>
    <p className="bodySmall neutral500">
      Conventional loans are one of the most popular types of mortgages. Nearly all home loans that
      aren’t backed by a federal agency are conventional mortgages. There are two main types of
      conventional mortgages: Conforming and non-conforming, or jumbo loans. Because they aren’t
      insured by the government, these loans have high credit and low debt-to-income requirements.
    </p>
    <br />
    <p className="semiBold">FHA Loan</p>
    <p className="bodySmall lighter">
      An FHA loan is a private mortgage that is insured by the Federal Housing Administration.
      Because of this added protection, these loans come with low interest rates and down payment
      requirements. To be eligible for an FHA loan, you’ll need to meet the borrower requirements,
      which include a credit score of at least 500 and a down payment of 3.5% to 10%.
    </p>
  </div>
)

export default LoanTypeModal
